define([
	"dojo/_base/config",
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/has",
	"dojo/when",
	"dijit/_TemplatedMixin",
	"dijit/_WidgetBase",
	"csi/def",
	"csi/html",
	"csi/sessionConstants",
	"csi/state",
	"csi/state/rootStore",
	"csi/view",
	"dojo/text!csi/templates/Debug.html"
], function(config, declare, lang, has, when, _TemplatedMixin, _WidgetBase, def, html, sessionConstants, state, {sessionStore}, csiView, template) {

	return declare([_WidgetBase, _TemplatedMixin], {
		templateString: template,

		postCreate: function() {
			// summary: if not already in debug mode, then only allow access to Debug Viewers
			if (!config.isDebug && !sessionConstants.debugViewer) {
				html.clear(this.domNode);
			}
		},

		_onClickDebug: function() {
			// summary: enter debug mode
			html.clear(this.domNode);
			has.add("csi-track-xhr", true);

			when(def.addDebugModule(), lang.hitch(this, this._onDebugStart));
		},

		_onDebugStart: function() {
			// summary: create debug tools view
			const {nonObservableCache, user} = sessionStore;
			var defView = def.getNodeViewDef(user, "DebugConsole");
			var view = csiView.newView(defView, user, {
				cacheView: nonObservableCache,
				shouldRenderViewActions: () => true
			}, true);

			view.placeAt(this.domNode);

			state.set("debugMode", true);
		}
	});
});